import RegisterReceiver from "./RegisterReceiver";

export default RegisterReceiver;
